/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCountryDto } from './GetCountryDto';
import {
    GetCountryDtoFromJSON,
    GetCountryDtoFromJSONTyped,
    GetCountryDtoToJSON,
} from './GetCountryDto';
import type { GetEmailAddressDto } from './GetEmailAddressDto';
import {
    GetEmailAddressDtoFromJSON,
    GetEmailAddressDtoFromJSONTyped,
    GetEmailAddressDtoToJSON,
} from './GetEmailAddressDto';

/**
 * 
 * @export
 * @interface GetClientExtendedWithCompanyIdDto
 */
export interface GetClientExtendedWithCompanyIdDto {
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    pesel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    place: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    street: string;
    /**
     * 
     * @type {GetCountryDto}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    country: GetCountryDto;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    numbers: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    flat: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    isRelated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    dealGroupNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    notToSymphony: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    signContractBlock: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    notSendMailFVS: boolean;
    /**
     * 
     * @type {Array<GetEmailAddressDto>}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    emailAddresses?: Array<GetEmailAddressDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    overduePaymentReminder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    paymentRequest: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    paymentRequestKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    paymentRequestBlockKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    interest: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    language: GetClientExtendedWithCompanyIdDtoLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    hasActivePurchaser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    hasActivePosition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetClientExtendedWithCompanyIdDto
     */
    companyId?: string;
}


/**
 * @export
 */
export const GetClientExtendedWithCompanyIdDtoLanguageEnum = {
    Pl: 'PL',
    En: 'EN'
} as const;
export type GetClientExtendedWithCompanyIdDtoLanguageEnum = typeof GetClientExtendedWithCompanyIdDtoLanguageEnum[keyof typeof GetClientExtendedWithCompanyIdDtoLanguageEnum];


/**
 * Check if a given object implements the GetClientExtendedWithCompanyIdDto interface.
 */
export function instanceOfGetClientExtendedWithCompanyIdDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "place" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "flat" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "isRelated" in value;
    isInstance = isInstance && "internal" in value;
    isInstance = isInstance && "dealGroupNumber" in value;
    isInstance = isInstance && "notToSymphony" in value;
    isInstance = isInstance && "signContractBlock" in value;
    isInstance = isInstance && "notSendMailFVS" in value;
    isInstance = isInstance && "overduePaymentReminder" in value;
    isInstance = isInstance && "paymentRequest" in value;
    isInstance = isInstance && "paymentRequestKRD" in value;
    isInstance = isInstance && "paymentRequestBlockKRD" in value;
    isInstance = isInstance && "interest" in value;
    isInstance = isInstance && "language" in value;

    return isInstance;
}

export function GetClientExtendedWithCompanyIdDtoFromJSON(json: any): GetClientExtendedWithCompanyIdDto {
    return GetClientExtendedWithCompanyIdDtoFromJSONTyped(json, false);
}

export function GetClientExtendedWithCompanyIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientExtendedWithCompanyIdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'shortname': json['shortname'],
        'name': json['name'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'pesel': !exists(json, 'pesel') ? undefined : json['pesel'],
        'postcode': json['postcode'],
        'place': json['place'],
        'street': json['street'],
        'country': GetCountryDtoFromJSON(json['country']),
        'numbers': json['numbers'],
        'flat': json['flat'],
        'active': json['active'],
        'isRelated': json['isRelated'],
        'internal': json['internal'],
        'dealGroupNumber': json['dealGroupNumber'],
        'notToSymphony': json['notToSymphony'],
        'signContractBlock': json['signContractBlock'],
        'notSendMailFVS': json['notSendMailFVS'],
        'emailAddresses': !exists(json, 'emailAddresses') ? undefined : (json['emailAddresses'] === null ? null : (json['emailAddresses'] as Array<any>).map(GetEmailAddressDtoFromJSON)),
        'overduePaymentReminder': json['overduePaymentReminder'],
        'paymentRequest': json['paymentRequest'],
        'paymentRequestKRD': json['paymentRequestKRD'],
        'paymentRequestBlockKRD': json['paymentRequestBlockKRD'],
        'interest': json['interest'],
        'language': json['language'],
        'hasActivePurchaser': !exists(json, 'hasActivePurchaser') ? undefined : json['hasActivePurchaser'],
        'hasActivePosition': !exists(json, 'hasActivePosition') ? undefined : json['hasActivePosition'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
    };
}

export function GetClientExtendedWithCompanyIdDtoToJSON(value?: GetClientExtendedWithCompanyIdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'shortname': value.shortname,
        'name': value.name,
        'nip': value.nip,
        'pesel': value.pesel,
        'postcode': value.postcode,
        'place': value.place,
        'street': value.street,
        'country': GetCountryDtoToJSON(value.country),
        'numbers': value.numbers,
        'flat': value.flat,
        'active': value.active,
        'isRelated': value.isRelated,
        'internal': value.internal,
        'dealGroupNumber': value.dealGroupNumber,
        'notToSymphony': value.notToSymphony,
        'signContractBlock': value.signContractBlock,
        'notSendMailFVS': value.notSendMailFVS,
        'emailAddresses': value.emailAddresses === undefined ? undefined : (value.emailAddresses === null ? null : (value.emailAddresses as Array<any>).map(GetEmailAddressDtoToJSON)),
        'overduePaymentReminder': value.overduePaymentReminder,
        'paymentRequest': value.paymentRequest,
        'paymentRequestKRD': value.paymentRequestKRD,
        'paymentRequestBlockKRD': value.paymentRequestBlockKRD,
        'interest': value.interest,
        'language': value.language,
        'hasActivePurchaser': value.hasActivePurchaser,
        'hasActivePosition': value.hasActivePosition,
        'companyId': value.companyId,
    };
}

